import { format } from "date-fns"

export const formatFriendlyDate = (date: Date) => {
  return format(date, "dd MMM yyyy")
}

export const formatFriendlyDateTime = (date: Date) => {
  return format(date, "dd MMM yyyy hh:mm")
}
